import { Application } from "@hotwired/stimulus"
import MobileAppPromoController from "../controllers/mobile_app_promo_controller.js"
import DesktopAppPromoController from "../controllers/desktop_app_promo_controller.js"

const application = Application.start()
application.register("mobile-app-promo", MobileAppPromoController)
application.register("desktop-app-promo", DesktopAppPromoController)
